import { styled } from "@mui/material";
import RadioButtonGroup from "../../../../../RadioButton/RadioButtonGroup";

export const StyledRadioButtonGroup = styled(RadioButtonGroup)`
  &.MuiFormControl-root {
    width: 100%;
  }

  &.MuiRadioGroup-row {
    display: flex;
    width: 100%;
    justify-content: center;
    background-color: ${({ theme }) => theme.wsc.palette.neutral[700]};
    border-bottom: 1px solid ${({ theme }) => theme.wsc.palette.neutral[600]};
    border-radius: ${({ theme }) => theme.wsc.radius.sm};
    z-index: 1;
    padding-top: ${({ theme }) => theme.wsc.spacing[1]};
    padding-bottom: ${({ theme }) => theme.wsc.spacing[1]};
  }
`;
